/* 9 Art Prints — customer words about the print drifting slowly across the wall behind the sheet in "See the paper up
   close" (Arif's idea, live 2026-10-19). Each quote is copied word for word from the review records
   (data/reviews; sources in reports/previews/paper-quotes-2026-10-19/quotes-with-sources.json), first name only;
   a long review is cut to whole sentences, never reworded.
   Arif, 2026-10-19: EB Garamond italic in one warm ink; the opening still glides straight in to the grain (people come
   for the paper) and the words appear only on the whole-picture view. Large type, one line each, few on screen,
   drifting right to left, so the start of each quote is read first. The sheet is cut out of the layer every frame, so the words pass behind the print and never
   cross it; they fade away as the view zooms in.
   Tried and rejected the same day: a script font; rising columns of wrapped quotes (too busy, then too far apart);
   a different colour per quote (house burgundy, antique gold, slate blue, olive — "a bad idea"); drifting left to
   right (the end of a quote arrives first and it reads as nonsense — Arif). */
(function () {
  'use strict';
  var QUOTES = [
    { q: 'The print is so exquisite that I literally gasped upon opening it!', by: 'Imani' },
    { q: 'Beautiful print, high quality paper', by: 'Kathleen' },
    { q: 'Beautiful paper and printing. Feels like a real woodblock print.', by: 'Philip' },
    { q: 'Smashing print quality', by: 'Nic' },
    { q: 'The illustration is as I hoped for, classic and the texture of paper, authentic!', by: 'Jules' },
    { q: 'Great prints on quality paper', by: 'Sarah' },
    { q: 'Wow- the quality of this item is amazing!', by: 'Cathleen' },
    { q: 'This print is absolutely stunning!', by: 'Tanya' },
    { q: 'Great quality print, colours are exactly as shown.', by: 'Ekaterina' },
    { q: 'Gorgeous colour and print quality!', by: 'Lorraine' },
    { q: 'I was so impressed by the quality and the packaging!', by: 'Scarlett' },
    { q: 'Vibrant and beautiful. Exceeded my expectations', by: 'Corina' },
    { q: 'Great piece and love the vibrant colors', by: 'Peter' },
    { q: 'Beautiful Print, excellent quality, exactly as described', by: 'Joy' },
    { q: 'Excellent quality and great colors.', by: 'Umaash' },
    { q: 'Beautiful print with vibrant colors.', by: 'Parimal' }
  ];
  var STILL = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var css = document.createElement('style');
  css.textContent =
    '.nine-pq{position:absolute;pointer-events:none;overflow:hidden;z-index:1;opacity:0}' +
    '.nine-pq__q{position:absolute;left:0;top:0;margin:0;white-space:nowrap;color:#4a4237;will-change:transform,opacity}' +
    '.nine-pq__t{display:inline;margin:0;font-family:"EB Garamond",Georgia,serif;font-style:italic;font-weight:400;line-height:1.2}' +
    '.nine-pq__by{display:inline;margin-left:1.1em;font:500 11px/1 var(--text-font-family,Helvetica,Arial,sans-serif);letter-spacing:.22em;text-transform:uppercase;opacity:.8;vertical-align:.45em}';
  document.head.appendChild(css);
  var fonts = document.createElement('link');
  fonts.rel = 'stylesheet'; fonts.href = 'https://fonts.googleapis.com/css2?family=EB+Garamond:ital@1&display=swap';
  document.head.appendChild(fonts);

  var next = 0;
  function quote() { var q = QUOTES[next]; next = (next + 1) % QUOTES.length; return q; }
  /* mixed sizes: short lines larger, long ones a little smaller, neighbours always differ */
  var lastSize = 0;
  function size(q, base) {
    var n = q.length, s = n < 32 ? 1.3 : n < 50 ? 1.12 : 0.95;
    var k = s * (0.92 + Math.random() * 0.2);
    if (Math.abs(k - lastSize) < 0.1) k += k > 1.1 ? -0.15 : 0.15;
    lastSize = k; return Math.round(base * k);
  }

  function attach(dlg) {
    var cv = dlg.querySelector('canvas'), layer = document.createElement('div');
    layer.className = 'nine-pq'; layer.setAttribute('aria-hidden', 'true');
    cv.after(layer);
    var live = [], lanes = {}, last = 0, shown = 0;

    function make(px) {
      var q = quote(), el = document.createElement('figure');
      el.className = 'nine-pq__q';
      el.innerHTML = '<blockquote class="nine-pq__t"></blockquote><figcaption class="nine-pq__by"></figcaption>';
      el.firstChild.textContent = '“' + q.q + '”'; el.lastChild.textContent = q.by;
      el.firstChild.style.fontSize = size(q.q, px) + 'px'; layer.appendChild(el);
      return { el: el, w: el.offsetWidth, h: el.offsetHeight };
    }

    /* a lane is one line of wall; a quote enters at the right and drifts left, behind the sheet and out the other
       side; the next in that lane waits until this one is well across, so only a few are on screen */
    function spawn(k, y, px, speed, x, W) {
      var o = make(px);
      o.k = k; o.y = y - o.h / 2; o.v = speed; o.x = x == null ? W + 8 : x - o.w;   /* x, when given, is where the quote's end sits */
      if (STILL) o.born = performance.now();
      live.push(o); lanes[k] = o; return o;
    }
    function frame(t) {
      /* closing the view keeps the quotes where they are; they carry on when it opens again (Arif, 2026-10-19) */
      if (!dlg.open) { last = 0; return; }
      requestAnimationFrame(frame);
      var v = dlg._viewer;
      layer.style.left = cv.offsetLeft + 'px'; layer.style.top = cv.offsetTop + 'px';
      layer.style.width = cv.offsetWidth + 'px'; layer.style.height = cv.offsetHeight + 'px';
      if (!v || !v.art) return;
      var d = v.dpr, W = cv.offsetWidth, H = cv.offsetHeight, cw = v.canvas.width, ch = v.canvas.height;
      var r = { x0: (cw / 2 - v.cx * v.zoom) / d, x1: (cw / 2 + (v.art.width - v.cx) * v.zoom) / d,
                y0: (ch / 2 - v.cy * v.zoom) / d, y1: (ch / 2 + (v.art.height - v.cy) * v.zoom) / d };
      var a = Math.max(0, r.x0 - 3), b = Math.max(0, r.y0 - 3), c = Math.min(W, r.x1 + 3), e = Math.min(H, r.y1 + 3);
      layer.style.clipPath = 'polygon(evenodd,0 0,' + W + 'px 0,' + W + 'px ' + H + 'px,0 ' + H + 'px,0 0,' +
        a + 'px ' + b + 'px,' + a + 'px ' + e + 'px,' + c + 'px ' + e + 'px,' + c + 'px ' + b + 'px,' + a + 'px ' + b + 'px)';
      /* only on the whole picture, and not during the opening glide, which goes straight to the grain */
      var zr = v.zoom / v.fitZoom(), on = !v.glideAt && (!v.zoomTarget || v.zoomTarget <= v.fitZoom() * 1.01) ? 1 : 0;
      var op = on * Math.max(0, Math.min(1, 1 - (zr - 1.05) / 0.3));
      shown += (op - shown) * 0.12; layer.style.opacity = shown < 0.01 ? 0 : shown.toFixed(3);
      /* zooming in pauses the quotes where they are instead of clearing them; back on the whole picture they carry
         on from there (Arif, 2026-10-19) */
      var go = on && zr < 1.15;
      var dt = last ? Math.min(0.1, (t - last) / 1000) : 0; last = t;
      if (go) {
        /* speeds 47–60 px/s (Arif, 2026-10-19: 26–34 "takes too long to read the sentences", then 35–45 "faster still").
           Beside the sheet (a computer): three lanes at different heights, out of step. No room beside it (a phone):
           one lane in the wall above the sheet and one below. */
        var wide = r.x0 >= 160 || W - r.x1 >= 160, L = [];
        if (wide) L = [['a', H * 0.2, 48, 54, 0.12], ['b', H * 0.52, 54, 47, -0.45], ['c', H * 0.82, 46, 60, 0.5]];
        else {
          /* the wall between the title and the sheet, and between the sheet and the hint: two lines where there is
             room, else one (the bars are gone, so the margins are wider than before — Arif, 2026-10-19) */
          var cr = cv.getBoundingClientRect(), tt = dlg.querySelector('.nine-paper-dlg__top > div'), bb = dlg.querySelector('.nine-paper-dlg__bar');
          var tb = tt ? tt.getBoundingClientRect().bottom - cr.top + 4 : 0, bt = bb ? bb.getBoundingClientRect().top - cr.top : H;
          var SP = { t0: [54, 0.05], t1: [46, -0.5], u0: [50, 0.3], u1: [43, -0.2] };
          [['t', tb, r.y0 - 4], ['u', r.y1 + 4, bt]].forEach(function (g) {
            var h = g[2] - g[1], n = h >= 96 ? 2 : h >= 46 ? 1 : 0;
            for (var i = 0; i < n; i++) L.push([g[0] + i, g[1] + h * (i + 0.5) / n, n === 2 ? 27 : 30, SP[g[0] + i][0], SP[g[0] + i][1]]);
          });
        }
        var fresh = !live.length;
        L.forEach(function (ln) {
          var o = lanes[ln[0]];
          if (!o) spawn(ln[0], ln[1], ln[2], ln[3], fresh ? W * (1 - ln[4]) : null, W);
          else if (!STILL && o.x + o.w < W * (wide ? 0.38 : 0.45)) spawn(ln[0], ln[1], ln[2], ln[3], null, W);
        });
      }
      live = live.filter(function (o) {
        var fade, done;
        if (!go) { if (STILL) o.born += dt * 1000; return true; }
        if (STILL) {
          var age = (t - o.born) / 1000; fade = Math.min(1, age / 1.2, (12 - age) / 1.2); done = age > 12;
          if (o.x < 0 || o.x + o.w > W) o.x = Math.max(8, (W - o.w) / 2);
        } else {
          o.x -= o.v * dt; done = o.x + o.w < -8;
          fade = Math.min(1, (o.x + o.w) / 140, (W - o.x) / 140);
        }
        if (done) { o.el.remove(); if (lanes[o.k] === o) delete lanes[o.k]; return false; }
        o.el.style.opacity = (0.72 * Math.max(0, Math.min(1, fade))).toFixed(3);
        o.el.style.transform = 'translate(' + o.x + 'px,' + o.y + 'px)';
        return true;
      });
    }
    new MutationObserver(function () { if (dlg.open) { last = 0; requestAnimationFrame(frame); } })
      .observe(dlg, { attributes: true, attributeFilter: ['open'] });
  }
  document.querySelectorAll('.nine-paper-dlg').forEach(attach);
})();
